<template>
  <div class="w-100 d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <v-icon
        color="iconDark"
        size="16px"
        icon="$file-document-outline"
        class="mr-1"
      />
      <span class="text-textDarkest">{{ csvConfig.label }}</span>
    </div>
    <DpplNewButton
      :disabled="exportInProgress"
      size="small"
      variant="outlined"
      color="brandPrimary"
      @click="handleCsvDownload"
    >
      Download CSV
    </DpplNewButton>
  </div>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { computed } from 'vue';
import { wait } from '@/helpers/wait';
import { useInsightsExport } from '@/stores/insights/export';
import { storeToRefs } from 'pinia';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useTracking } from '@/stores/tracking/tracking';
import { useRoute } from 'vue-router';

const route = useRoute();
const emits = defineEmits(['close']);

const props = defineProps({
  exportConfig: {
    type: Object,
    required: true,
  },
});

const { exportInProgress } = storeToRefs(useInsightsExport());

const { updateExportInProgress } = useInsightsExport();
const {
  addErrorSnackbar,
  addSuccessSnackbar,
} = useAppSnackbar();

const csvConfig = computed(() => ({
  label: props.exportConfig.csvOptions[0].label || '',
  downloadFunction: props.exportConfig.csvOptions[0].csvDownloadFunction || (() => {}),
  waitTime: props.exportConfig.csvOptions[0].waitTime || 2000,
}));

const handleCsvDownload = async () => {
  try {
    updateExportInProgress(true);

    if (csvConfig.value.downloadFunction.constructor.name === 'AsyncFunction') {
      await csvConfig.value.downloadFunction();
    } else {
      csvConfig.value.downloadFunction();

      // Simulate download time in case it takes a second
      await wait(csvConfig.value.waitTime);
    }

    useTracking().insightsDownloadReport({
      reportName: route.name,
      downloadType: 'Individual Widgets',
      downloadLocation: 'Download Modal',
      fileType: 'CSV',
      widgetName: csvConfig.value.label,
    });

    addSuccessSnackbar({
      text: 'CSV downloaded successfully',
    });
  } catch (error) {
    addErrorSnackbar({ text: 'Failed to download CSV' });
    throw error;
  } finally {
    updateExportInProgress(false);
    emits('close');
  }
};
</script>
